import { useCallback } from 'react'
import { parseAsString, useQueryState } from 'nuqs'

export const SELECTED_CONVERSATION_PARAM = 'conversation'

type UseSelectedConversationReturn = {
  /** The conversation the thread pane renders, or `undefined` for none. */
  selectedConversationId: string | undefined
  selectConversation: (conversationId: string) => void
  clearSelection: () => void
}

/**
 * The selected conversation lives in the URL, so a thread survives a reload
 * and can be linked to. Selection replaces rather than pushes: moving down a
 * conversation list must not fill the history stack.
 */
export function useSelectedConversation(): UseSelectedConversationReturn {
  const [selectedConversationId, setSelectedConversationId] = useQueryState(
    SELECTED_CONVERSATION_PARAM,
    parseAsString.withOptions({ history: 'replace' }),
  )

  const selectConversation = useCallback(
    (conversationId: string): void => {
      void setSelectedConversationId(conversationId)
    },
    [setSelectedConversationId],
  )

  const clearSelection = useCallback((): void => {
    void setSelectedConversationId(null)
  }, [setSelectedConversationId])

  return {
    selectedConversationId: selectedConversationId ?? undefined,
    selectConversation,
    clearSelection,
  }
}
